import React from "react";
import * as agent from "../agent";
import { connect } from "react-redux";
import { Field, formValueSelector, reduxForm, change } from "redux-form";
import { required, formatDate, validateDate, normalizeRate } from "../utility";
import { Masks, Credit } from "../constants/enums";
import MaterialAutocomplete from "./MaterialAutocomplete";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { MaterialTextField, MaterialMaskedTextField } from "./MaterialInput";
import MenuItem from "@material-ui/core/MenuItem";

const editCreditForm = ({
    isAdmin,
    inputType,
    inputSide,
    companies,
    companiesLoaded,
    managers,
    managersLoaded,
    handleTypeChange,
    onEditCredit,
    credit,
    handleSubmit
}) => {
    return (
        <form
            className="common-form common-column"
            onSubmit={handleSubmit(data => onEditCredit(credit._id, data))}
        >
            <Field
                name="type"
                select
                validate={required}
                onChange={handleTypeChange}
                component={MaterialTextField}
                label="Тип"
            >
                {Object.keys(Credit.Types).map((t, i) => {
                    return (
                        <MenuItem key={i} value={t}>
                            {Credit.Types[t]}
                        </MenuItem>
                    );
                })}
            </Field>
            <Field
                name="side"
                select
                validate={required}
                disabled={inputType === "CREDIT"}
                component={MaterialTextField}
                label="Сторона учета"
            >
                {Object.keys(Credit.Sides).map((s, j) => {
                    return (
                        <MenuItem key={j} value={s}>
                            {Credit.Sides[s]}
                        </MenuItem>
                    );
                })}
            </Field>
            <Field
                name="date"
                component={MaterialMaskedTextField}
                disabled={!isAdmin}
                validate={validateDate}
                mask={Masks.date}
                label="Дата"
            />
            <Field
                name="prolongationDate"
                component={MaterialMaskedTextField}
                disabled={!isAdmin}
                validate={validateDate}
                mask={Masks.date}
                label="Оплачен по"
            />
            <Field
                component={MaterialTextField}
                select
                name="manager"
                validate={required}
                disabled={!managersLoaded}
                label="Исполнитель"
            >
                {managers.map(({ _id, fullname }, i) => {
                    const [
                        managerLastname,
                        managerFirstname = "",
                        managerThirdname = ""
                    ] = fullname.split(" ");
                    return (
                        <MenuItem
                            key={i}
                            value={_id}
                        >{`${managerLastname} ${managerFirstname[0]}. ${managerThirdname[0]}.`}</MenuItem>
                    );
                })}
            </Field>
            <Field
                name="company"
                select
                validate={required}
                disabled={!companiesLoaded}
                component={MaterialTextField}
                label={`Компания${
                    inputSide
                        ? { DEBIT: "-займополучатель", CREDIT: "-займодатель" }[
                              inputSide
                          ]
                        : ""
                }`}
            >
                {companies.map(({ _id, name }, i) => (
                    <MenuItem key={i} value={_id}>
                        {name}
                    </MenuItem>
                ))}
            </Field>
            <Field
                component={MaterialAutocomplete}
                name="counterparty"
                validate={required}
                formatTextValue={c => `${c.name}`}
                getInitialValue={agent.Counterparty.getById}
                getSuggestionsMethod={agent.Counterparty.getByName}
                label={`Контрагент${
                    inputSide
                        ? { DEBIT: "-займодатель", CREDIT: "-займополучатель" }[
                              inputSide
                          ]
                        : ""
                }`}
            />
            <Field
                component={MaterialTextField}
                name="duration"
                validate={required}
                endAdornment="дн."
                label="Срок займа"
            />
            <Field
                component={MaterialTextField}
                name="rate"
                normalize={normalizeRate}
                validate={required}
                endAdornment="%"
                label="Годовая ставка"
            />
            <Button
                type="submit"
                fullWidth
                color="primary"
                size="large"
                variant="contained"
            >
                Сохранить
            </Button>
        </form>
    );
};

const EditCreditForm = connect(
    (state, props) => {
        const { credit } = props;
        return {
            isAdmin: state.common.user.permissions.includes(
                "forms-full-access"
            ),
            inputType: formValueSelector("edit-credit-form")(state, "type"),
            inputSide: formValueSelector("edit-credit-form")(state, "side"),
            initialValues: {
                ...credit,
                prolongationDate: formatDate(new Date(credit.prolongationDate)),
                date: formatDate(new Date(credit.date))
            }
        };
    },
    (dispatch, props) => ({
        handleTypeChange: e => {
            dispatch(
                change(
                    "edit-credit-form",
                    "side",
                    e.target.value === "CREDIT" ? "DEBIT" : ""
                )
            );
        }
    })
)(
    reduxForm({ form: "edit-credit-form", enableReinitialize: true })(
        editCreditForm
    )
);

class EditCredit extends React.Component {
    state = {
        accountsLoaded: false,
        accounts: [],
        operationsLoaded: false,
        operations: [],
        companiesLoaded: false,
        companies: [],
        counterpartiesLoaded: false,
        counterparties: [],
        managersLoaded: false,
        managers: []
    };

    componentDidMount = () => setTimeout(this.fetchData, 200);
    fetchData = () => {
        this.fetchManagers();
        this.fetchCounterparties();
        this.fetchOperations();
        this.fetchCompanies();
        this.fetchAccounts();
    };
    fetchAccounts = () => {
        agent.Account.getAll()
            .then(res => this.setState({ accountsLoaded: true, accounts: res }))
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    fetchCompanies = () => {
        agent.Company.getAll()
            .then(res =>
                this.setState({ companiesLoaded: true, companies: res })
            )
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    fetchManagers = () => {
        agent.User.managers()
            .then(res =>
                this.setState({ managersLoaded: true, managers: res.managers })
            )
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    fetchOperations = () => {
        agent.Operation.getAll()
            .then(res =>
                this.setState({ operationsLoaded: true, operations: res })
            )
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    fetchCounterparties = () => {
        agent.Counterparty.getAll()
            .then(res =>
                this.setState({
                    counterpartiesLoaded: true,
                    counterparties: res
                })
            )
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };
    onEditCredit = (creditId, data) => {
        const { updateCredit, dispatch } = this.props;
        agent.Credit.edit(creditId, data)
            .then(res => {
                dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: "Изменения сохранены", type: "success" }
                });
                updateCredit(res);
            })
            .catch(e =>
                this.props.dispatch({
                    type: MESSAGE_SENDED,
                    payload: { text: e.message, type: "error" }
                })
            );
    };

    render() {
        const { credit } = this.props;
        const {
            counterpartiesLoaded,
            counterparties,
            accountsLoaded,
            accounts,
            operationsLoaded,
            operations,
            companiesLoaded,
            companies,
            managersLoaded,
            managers
        } = this.state;

        return (
            <Paper
                className="common-paper"
                style={{ marginTop: 20, marginBottom: 20 }}
            >
                <EditCreditForm
                    companies={companies}
                    companiesLoaded={companiesLoaded}
                    counterparties={counterparties}
                    counterpartiesLoaded={counterpartiesLoaded}
                    accountsLoaded={accountsLoaded}
                    accounts={accounts}
                    operationsLoaded={operationsLoaded}
                    operations={operations}
                    managersLoaded={managersLoaded}
                    managers={managers}
                    credit={credit}
                    onEditCredit={this.onEditCredit}
                />
            </Paper>
        );
    }
}

export default connect(null, null)(EditCredit);



// WEBPACK FOOTER //
// ./src/components/EditCredit.js